// Central source for all three divisions' contact info
// Used in Navbar footer, contact pages, and division landing pages

export const DIVISIONS = {
  veteran: {
    id: "veteran",
    name: "Veteran Disability Consulting",
    shortName: "Veteran Services",
    slug: "/veteran-services",
    phone: "786-519-7988",
    phoneHref: "tel:+17865197988",
    email: "info@noblestrategiesconsulting.com",
    tagline: "Helping veterans navigate the VA disability claims process with clarity and strategy.",
  },
  insurance: {
    id: "insurance",
    name: "Insurance Solutions",
    shortName: "Insurance",
    slug: "/insurance",
    phone: "786-645-7229",
    phoneHref: "tel:+17866457229",
    email: "mvega@noblestrategiesconsulting.com",
    tagline: "Life, final expense, mortgage, income, family & retirement protection.",
  },
  education: {
    id: "education",
    name: "Education Assistance",
    shortName: "Education",
    slug: "/education",
    phone: "786-519-7988",
    phoneHref: "tel:+17865197988",
    email: "info@noblestrategiesconsulting.com",
    tagline: "VR&E, GI Bill, college & trade planning, and career transition guidance.",
  },
};

export const COMPANY = {
  name: "Noble Strategies Consulting",
  domain: "noblestrategiesconsulting.com",
  scheduleUrl: "https://calendar.app.google/jxk5PDJ9hEZ3mnXf9",
};
